import callGetFunction from './call-function-with-authenticated-user';
import { GET_CLIENT_CONFIG } from './functions-path';

export default (params = {}) => callGetFunction(GET_CLIENT_CONFIG, params);
